<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0 p-5" style="    margin: 1vw .9vw;">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <small class="fw-bolder"><span>تدوین ارکان جهت ساز</span> / <span>آینده    </span> /
            <span>{{ name_route }}</span></small>
          <button class="btn btn-primary btn-submit-1"
                  @click="$router.push('/Vision_working_group_Gary_Hamel_questionnaire')">برگشت
          </button>
        </div>
        <hr class="mb-3">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <div class="col-lg-4 mb-3 mx-1">
              <label class="form-label">صنعت</label>
              <textarea v-model="industry" name="" class="form-control" id="" cols="30" rows="10"></textarea>
            </div>
            <div class="col-lg-4 mb-3 mx-1">
              <label class="form-label">کشور</label>
              <textarea v-model="country" name="" class="form-control" id="" cols="30" rows="10"></textarea>
            </div>
            <div class="col-lg-4 mb-3 mx-1">
              <label class="form-label">فراملی</label>
              <textarea v-model="transnational" name="" class="form-control" id="" cols="30" rows="10"></textarea>
            </div>

          </div>
          <div class="d-flex align-items-center justify-content-center">
            <button v-if="is_update" @click.prevent="update(id_item)" class="btn btn-primary btn-submit-1">بروزرسانی</button>
            <Reset v-if="is_update" @click.prevent="reset" style="width: 2vw; height: 2vw;" class="mx-2" />
            <button v-else @click.prevent="store" class="btn btn-primary btn-submit-1">ذخیره</button>

          </div>
        </div>
        <hr class="mt-2 mb-2">
        <table v-if="all_items.length" class="table">
          <thead>
          <tr >
            <th style="width: 1vw;">ردیف</th>
            <th >موارد</th>
            <th>صنعت</th>
            <th>کشور</th>
            <th>فراملی</th>
            <th style="width: 5vw">عملیات</th>
          </tr>
          </thead>
          <tr v-for="(item,index) in all_items">
            <td>{{index+1}}</td>
            <td>{{item.type}}</td>
            <td>{{item.industry}}</td>
            <td>{{item.country}}</td>
            <td>{{item.transnational}}</td>
            <td>
              <div class="d-flex" style="height: 2.3vw;">
                <p style="width: 2vw;" @click.prevent="deleteMethod(item.id)" href="#"><img class="table-delete-img mx-2" src="/img/delete.f9fc94bc.svg" alt="delete"> </p>
                <p  style="width: 2vw; " @click.prevent="edit(item.id, item.industry, item.country, item.transnational)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></p>
              </div>
            </td>
          </tr>
        </table>
        <center v-else>
          <p>موردی یافت نشد!</p>
        </center>
        <hr class="mt-2 mb-2">
        <div class="d-flex justify-content-between">
          <p @click.prevent="previousPage" class="btn btn-submit-1 btn-primary">مرحله قبلی</p>
          <p @click.prevent="nextPage" class="btn btn-submit-1 btn-primary">مرحله بعدی</p>
        </div>


      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 55%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="submit_delete(id_item)">تایید</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";

const toast = useToast();

export default {
  name: 'HomeView',
  components: {
    Reset,
    Sidebar,
    splash
  },
  data() {
    return {
      id_route: this.$route['params']['id'],
      name_route: '',
      text: '',
      all_items: [],
      id_item: '',
      is_update: false,
      deleteModal: false,
      industry: '',
      country: '',
      transnational: '',

    }
  },
  methods: {
    edit(id,industry,country,transnational){
      this.industry = industry
      this.country = country
      this.transnational = transnational
      this.id_item = id
      this.is_update = true
    },
    reset(){
      this.is_update=false
      this.text = ''
      this.industry = ''
      this.country = ''
      this.transnational = ''

    },
    update(id){
      if (!this.industry){
        toast.error('صنعت اجباری است!')
        return;
      } else if (!this.country){
        toast.error('کشور اجباری است!')
        return;
      } else if (!this.transnational){
        toast.error('فرامی اجباری است!')
        return;
      }
      fetch(`${this.base_url}/FutureQuestionnaire/update/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'industry': this.industry,
          'country': this.country,
          'transnational': this.transnational,
        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message) {
              toast.success(response.message)

              this.all()
              this.reset()
            }


          }).catch((err) => {
      })
    },
    deleteMethod(id){
      this.id_item = id
      this.deleteModal = true

    },
    submit_delete(id){
      fetch(`${this.base_url}/FutureQuestionnaire/destroy/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'industry': this.industry,
          'country': this.country,
          'transnational': this.transnational,
        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message) {
              toast.success(response.message)

              this.deleteModal = false
              this.all()
              this.reset()
            }


          }).catch((err) => {
      })
    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }

    },
    getName() {
      if (parseInt(this.id_route) === 1) this.name_route = 'جایگاه مطلوب مورد نظر سازمان/ شرکت بر اساس | عوامل کلیدی مستمر الگو';
      else if (parseInt(this.id_route) === 2) this.name_route = 'جایگاه مطلوب مورد نظر سازمان/ شرکت بر مبنای بیانیه عزم مدیریت استراتژیک';
      else if (parseInt(this.id_route) === 3) this.name_route = 'جایگاه مطلوب مورد نظر سازمان/ شرکت بر اساس بیانیه ماموریت';
      else if (parseInt(this.id_route) === 4) this.name_route = 'جایگاه مطلوب مورد نظر سازمان/ شرکت با توجه به الزامات محیطی';
      else if (parseInt(this.id_route) === 5) this.name_route = 'جایگاه مطلوب مورد نظر سازمان/ شرکت بر مبنای الزامات داخلی';
      else if (parseInt(this.id_route) === 6) this.name_route = 'جایگاه مطلوب مورد نظر سازمان/ شرکت بر اساس چشم انداز بالادستی';

    },

    previousPage() {

      let num = parseInt(this.id_route) - 1
      if (num === 0) {
        router.push('/Vision_working_group_Gary_Hamel_questionnaire/ByType')

        return
      }
      router.push(`/Vision_working_group_future/ByType/${num}`)
      this.id_route = num
      this.getName()
      this.all()
    },
    nextPage() {
      let num = parseInt(this.id_route) + 1
      if (num === 7) {
        return
      }
      router.push(`/Vision_working_group_future/ByType/${num}`)
      this.id_route = num
      this.getName()
      this.all()

    },
    all() {
      fetch(`${this.base_url}/FutureQuestionnaire`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'type': this.id_route,
        }),
      })
          .then(response => response.json())
          .then((response) => {

            this.all_items.length=0
            this.all_items = [...response.data]


          }).catch((err) => {
      })
    },
    store() {
      if (!this.industry){
        toast.error('صنعت اجباری است!')
        return;
      } else if (!this.country){
        toast.error('کشور اجباری است!')
        return;
      } else if (!this.transnational){
        toast.error('فرامی اجباری است!')
        return;
      }
      fetch(`${this.base_url}/FutureQuestionnaire/store`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'type': this.id_route,
          'industry': this.industry,
          'country': this.country,
          'transnational': this.transnational,
        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message) {
              toast.success(response.message)
              this.text = ''
              this.all()
              this.reset()
            }


          }).catch((err) => {
      })
    }
  },
  mounted() {
    this.checkIsMother()
    this.getName()
    this.all()

  }
}
</script>
<style scoped lang="scss">
a {
  font-size: 1vw;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/

h3 {
  font-size: 1.3vw !important;
}

small {
  font-size: 1vw !important;
}

textarea {
  height: 6vw !important;
}
</style>